/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import CloseIcon from "../../icons/CloseIcon";
import messages from "../../../helpers/messages";

function SalesViewPendingBidState({ hideBanner }) {
  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.bidSuccessfullyUploadedMessage.defaultMessage}
      </p>
      <CloseIcon
        height="16px"
        width="16px"
        className="fr cursor-pointer mt-16 mr-24"
        onClick={hideBanner}
      />
    </>
  );
}

export default SalesViewPendingBidState;
